import { updateHighlights } from 'modules/state/models';
import { StandardThunkAction } from 'types';
import { Action, actionCreator } from 'util/actions';
import { createReducer } from 'util/reducers';

import {
  clearHighlightActions,
  LOAD_HIGHLIGHT_ACTIONS_ERROR,
  LOAD_HIGHLIGHT_ACTIONS_REQUEST,
  LOAD_HIGHLIGHT_ACTIONS_SUCCESS,
  loadHighlightActions,
  LoadHighlightActionsErrorAction,
  LoadHighlightActionsRequestAction,
  LoadHighlightActionsSuccessAction,
} from 'modules/loaders';

const SET_VISIBLE_ID_HIGHLIGHTS = Symbol('ui/SET_VISIBLE_ID_HIGHLIGHTS');

type SetVisibleIdHighlightsAction = Action<
  typeof SET_VISIBLE_ID_HIGHLIGHTS,
  string[]
>;

const setVisibleIdHighlights = actionCreator<SetVisibleIdHighlightsAction>(
  SET_VISIBLE_ID_HIGHLIGHTS,
);

export interface UiHighlightsState {
  loading: boolean;
  visibleIdHighlights: string[];
}

const initialState: UiHighlightsState = {
  loading: false,
  visibleIdHighlights: [],
};

export default createReducer(initialState, {
  [LOAD_HIGHLIGHT_ACTIONS_REQUEST](
    state,
    { payload }: LoadHighlightActionsRequestAction,
  ) {
    return {
      ...state,
      loading: true,
    };
  },

  [LOAD_HIGHLIGHT_ACTIONS_SUCCESS](
    state,
    { payload }: LoadHighlightActionsSuccessAction,
  ) {
    return {
      ...state,
      loading: false,
    };
  },

  [LOAD_HIGHLIGHT_ACTIONS_ERROR](
    state,
    { payload }: LoadHighlightActionsErrorAction,
  ) {
    return {
      ...state,
      loading: false,
    };
  },

  [SET_VISIBLE_ID_HIGHLIGHTS](
    state,
    { payload }: SetVisibleIdHighlightsAction,
  ) {
    return {
      ...state,
      visibleIdHighlights: payload,
    };
  },
});

export const updateVisibleHighlights = (): StandardThunkAction<void> => {
  return (dispatch, getState) => {
    dispatch(updateHighlights());

    const { idHighlights } = getState().models.highlights;

    dispatch(setVisibleIdHighlights(idHighlights));
  };
};

export const loadVisibleHighlights = (idTeam?: string): StandardThunkAction => {
  return async (dispatch, getState) => {
    dispatch(clearHighlightActions());
    dispatch(updateVisibleHighlights());

    await dispatch(loadHighlightActions(idTeam));

    dispatch(updateVisibleHighlights());
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/ui/highlights.ts